import {
    dataMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    object,
    moreNav,
    agendaViewConfig,
    // SellsyAdmin
    sellsyAdminCommonTabs,
    samTabs,
} from './ThirdMapping';

import { setDatabotsNavMap } from 'js/vue/helpers';

var entitiesGroups = [
    {
        label: Loc.g('Activité'),
        value: 'clientActivity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'supplier', 'timetracking'],
    },
    {
        label: Loc.g('Prospection'),
        value: 'prospection',
        entities: ['campaign', 'opportunity', 'estimate', 'propdocument'],
    },
];

var entitiesTabs = [
    {
        label: Loc.g('Activité'),
        value: 'activity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people'],
    },
    {
        label: Loc.g('Éléments épinglés'),
        value: 'pinned',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people'],
    },
    {
        label: Loc.g('Commentaires'),
        value: 'note',
        entities: ['annotation'],
        databot: 'supplier-overview__activity--comment-list',
    },
    {
        label: Loc.g('Emails'),
        value: 'email',
        entities: ['email'],
        databot: 'supplier-overview__activity--email-list',
    },
    {
        label: Loc.g('Tâches'),
        value: 'task',
        entities: ['task'],
        databot: 'supplier-overview__activity--task-list',
    },
    {
        label: Loc.g('Evènements'),
        value: 'event',
        entities: ['event'],
        databot: 'supplier-overview__activity--event-list',
    },
    {
        label: Loc.g('Appels'),
        value: 'phonecall',
        entities: ['phonecall'],
        databot: 'supplier-overview__activity--call-list',
    },
];

var defaultEntities = [
    'email',
    'phonecall',
    'supplier',
    'annotation',
    'event',
    'task',
    'timetracking',
    'campaign',
    'opportunity',
    'estimate',
    'propdocument',
];

var forcedLabel = [
    {
        value: 'supplier',
        label: Loc.g('Mises à jour'),
    },
];

var navMap = [
    {
        id: 'informations',
        label: '',
        items: [
            {
                id: 'activity',
                label: Loc.g('Activité'),
                group: false,
                component: 'tab-activity',
                permission: 'can_show_activity',
                keepalive: false,
                more: {},
            },
            {
                id: 'informations',
                label: Loc.g('Informations générales'),
                group: false,
                component: 'tab-informations-third',
                more: {},
            },
            {
                id: 'preferences',
                label: Loc.g('Préférences'),
                group: false,
                component: 'tab-preferences',
                more: {
                    buttons: [
                        {
                            type: 'function',
                            label: Loc.g('Editer'),
                            primary: true,
                            permission: 'can_edit',
                            event: 'edit',
                            params: {},
                        },
                    ],
                },
            },
            {
                id: 'contacts',
                label: Loc.g('Contacts associés'),
                group: false,
                component: 'tab-contacts',
                permission: 'can_show_contacts',
                more: {
                    buttons: [
                        {
                            label: Loc.g('Ajouter / Lier un contact'),
                            callback: "javascript:People.linkTo('third', {id});",
                        },
                    ],
                },
            },
            {
                id: 'addresses',
                label: Loc.g('Adresses'),
                group: false,
                component: 'tab-addresses',
                permission: 'can_show_addresses',
                more: {
                    buttons: [
                        {
                            id: 'seemap',
                            type: 'function',
                            label: Loc.g('Voir la carte'),
                            primary: false,
                            event: 'openAddressMap',
                            dataUpsell: 'map_listing',
                        },
                        {
                            id: 'add',
                            type: 'function',
                            label: Loc.g('Ajouter une adresse'),
                            primary: true,
                            permission: 'can_create_addresses',
                            event: 'openAddress',
                        },
                    ],
                },
            },
            {
                id: 'customfields',
                label: Loc.g('Champs personnalisés'),
                group: false,
                component: 'tab-customfields',
                more: {
                    url: '/rest/thirds/{linkedid}/custom-field-values',
                    buttons: [
                        {
                            type: 'function',
                            label: Loc.g('Editer'),
                            primary: true,
                            permission: 'can_edit',
                            event: 'openCustomfields',
                            params: {},
                        },
                    ],
                },
            },
            // {
            //     id: 'statistics',
            //     label: Loc.g("Statistiques"),
            //     group: false,
            //     // component: 'tab-statistics',
            //     component: 'tab-in-progress',
            //     more: {}
            // }
        ],
    },
    {
        id: 'plugin',
        label: Loc.g('Modules'),
        items: [
            {
                id: 'purOrder',
                label: Loc.g('Bons de commande fournisseur'),
                group: {
                    id: 'documents',
                    label: Loc.g('Documents'),
                },
                component: 'tab-listingv1',
                permission: 'can_show_purchase_docs_purorder',
                more: {
                    title: Loc.g('Bons de commande fournisseur'),
                    listingname: 'docthirdspurOrder',
                    url: '/?_f=third',
                    action: 'loadDocTab',
                    doctype: 'purOrder',
                    callbackKeyName: 'docsListing',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer un bon de commande'),
                            permission: 'can_create_purchase_docs_purorder',
                            callback:
                                "javascript:DocTools.createForThird('purOrder', 'Créer un bon de commande', true, '', {linkedid});",
                        },
                    ],
                },
            },
            {
                id: 'purDelivery',
                label: Loc.g('Bons de livraison fournisseur'),
                group: {
                    id: 'documents',
                    label: Loc.g('Documents'),
                },
                component: 'tab-listingv1',
                permission: 'can_show_purchase_docs_purdelivery',
                more: {
                    title: Loc.g('Bons de livraison fournisseur'),
                    listingname: 'docthirdspurDelivery',
                    url: '/?_f=third',
                    action: 'loadDocTab',
                    doctype: 'purDelivery',
                    callbackKeyName: 'docsListing',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer un bon de livraison'),
                            permission: 'can_create_purchase_docs_purdelivery',
                            callback:
                                "javascript:DocTools.createForThird('purDelivery', 'Créer un bon de commande', true, '', {linkedid});",
                        },
                    ],
                },
            },
            {
                id: 'purInvoice',
                label: Loc.g('Factures fournisseur'),
                group: {
                    id: 'documents',
                    label: Loc.g('Documents'),
                },
                component: 'tab-listingv1',
                permission: 'can_show_purchase_docs_purinvoice',
                more: {
                    title: Loc.g('Facture fournisseur'),
                    listingname: 'docthirdspurInvoice',
                    url: '/?_f=third',
                    action: 'loadDocTab',
                    doctype: 'purInvoice',
                    callbackKeyName: 'docsListing',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer une facture'),
                            permission: 'can_create_purchase_docs_purinvoice',
                            callback:
                                "javascript:DocTools.createForThird('purInvoice', 'Créer une facture', true, '', {linkedid});",
                        },
                    ],
                },
            },
            {
                id: 'purCreditNote',
                label: Loc.g('Avoirs fournisseur'),
                group: {
                    id: 'documents',
                    label: Loc.g('Documents'),
                },
                component: 'tab-listingv1',
                permission: 'can_show_purchase_docs_purcreditnote',
                more: {
                    title: Loc.g('Avoir fournisseur'),
                    listingname: 'docthirdspurCreditNote',
                    url: '/?_f=third',
                    action: 'loadDocTab',
                    doctype: 'purCreditNote',
                    callbackKeyName: 'docsListing',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer un avoir'),
                            permission: 'can_create_purchase_docs_purcreditnote',
                            callback:
                                "javascript:DocTools.createForThird('purCreditNote', 'Créer un avoir', true, '', {linkedid});",
                        },
                    ],
                },
            },
            {
                id: 'payments',
                label: Loc.g('Règlements'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_payments',
                more: {
                    title: Loc.g('Règlements'),
                    listingname: 'payments',
                    url: '/?_f=third',
                    action: 'loadListingTab',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Ajouter un règlement'),
                            permission: true,
                            callback: "javascript:Payment.edit('', {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'bankaccount',
                label: Loc.g('Comptes & Cartes bancaires'),
                group: false,
                component: 'tab-account-credit-card',
                permission: 'can_show_bankaccount',
                more: {
                    title: Loc.g('Comptes & Cartes bancaires"'),
                    buttons: [],
                },
            },
            {
                id: 'recurring',
                label: Loc.g('Abonnements'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_recurring',
                more: {
                    title: Loc.g('Abonnements'),
                    listingname: 'recurring',
                    url: '/?_f=third',
                    action: 'loadListingTab',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer un abonnement'),
                            permission: 'can_create_recurring',
                            callback: 'DocRecurring.editRecurring();',
                        },
                    ],
                },
            },
            {
                id: 'mandates',
                label: Loc.g('Mandats'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_mandates',
                more: {
                    title: Loc.g('Mandats'),
                    listingname: 'mandates',
                    url: '/?_f=gocardless_mandates',
                    action: 'loadListingTab',
                    buttons: [],
                },
            },
            {
                id: 'timetracking',
                label: Loc.g('Timetracking'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_timetracking',
                more: {
                    title: Loc.g('Timetracking'),
                    listingname: 'timetracking',
                    url: '/?_f=third',
                    action: 'loadListingTab',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer une entrée'),
                            permission: true,
                            callback:
                                "javascript:TimetrackingEntry.edit('', '', '', '', {linkedid});",
                        },
                    ],
                },
            },
            {
                id: 'tickets',
                label: Loc.g('Support'),
                group: false,
                component: 'tab-2-columns',
                permission: 'can_show_tickets',
                more: {
                    title: Loc.g('Support'),
                    url: '/?_f=support_tickets',
                    action: 'loadThirdTab',
                    thirdid: '{linkedid}',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer un ticket'),
                            permission: 'can_create_ticket',
                            callback: 'javascript:Ticket.add({linkedid});',
                        },
                    ],
                },
            },
            {
                id: 'project',
                label: Loc.g('Projets'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_project',
                more: {
                    title: Loc.g('Projets'),
                    listingname: 'project',
                    url: '/?_f=third',
                    action: 'loadListingTab',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer un projet'),
                            permission: 'can_create_project',
                            callback: 'javascript:project.projectForm();',
                        },
                    ],
                },
            },
            {
                id: 'proposal',
                label: Loc.g('Documents redactor'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_proposal',
                more: {
                    title: Loc.g('Documents redactor'),
                    listingname: 'proposal',
                    url: '/?_f=tabs',
                    action: 'loadListingTab',
                    context: 'third',
                    prefilter: '{"third": {linkedid}}',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: Loc.g('Créer un document redactor'),
                            permission: 'can_create_proposal_document',
                            callback: "javascript:Proposal.create('propdocument');",
                        },
                    ],
                },
            },
            {
                id: 'emailingprofile',
                label: Loc.g('Profil emailing'),
                group: {
                    id: 'mailinglist',
                    label: Loc.g('Mailing lists'),
                },
                component: 'tab-listingv1',
                permission: 'can_show_mailinglist',
                more: {
                    tabType: 'total',
                    callbackKeyName: 'massMailingProfile',
                    title: Loc.g("Profil d'emailing"),
                    listingname: '',
                    url: '/?_f=massmailing_ajax',
                    action: 'loadMassMailingContactProfile',
                    type: 'corporation',
                    id: '{linkedid}',
                    buttons: [],
                },
            },
            {
                id: 'massmailingMailingList',
                label: Loc.g('Mailing lists'),
                group: {
                    id: 'mailinglist',
                    label: Loc.g('Mailing lists'),
                },
                component: 'tab-listingv1',
                permission: 'can_show_mailinglist',
                more: {
                    title: Loc.g('Mailing lists'),
                    listingname: 'massmailingMailinglist',
                    url: '/?_f=massmailing_ajax',
                    action: 'loadMassMailingContactListingTab',
                    type: 'third',
                    id: '{linkedid}',
                    buttons: [],
                },
            },
            {
                id: 'massmailingCampaignList',
                label: Loc.g('Liste des campagnes'),
                group: {
                    id: 'mailinglist',
                    label: Loc.g('Mailing lists'),
                },
                component: 'tab-listingv1',
                permission: 'can_show_mailinglist',
                more: {
                    title: Loc.g('Liste des campagnes'),
                    listingname: 'massmailingCampaignList',
                    url: '/?_f=massmailing_ajax',
                    action: 'loadMassMailingContactListingTab',
                    type: 'corporation',
                    id: '{linkedid}',
                    buttons: [],
                },
            },
            {
                id: 'receipts',
                label: Loc.g('Caisse'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_receipts',
                more: {
                    title: Loc.g('Caisse'),
                    listingname: 'receipts',
                    url: '/?_f=third',
                    action: 'loadListingTab',
                    buttons: [],
                },
            },
            {
                id: 'briefcase',
                label: Loc.g('Fichiers'),
                group: false,
                component: 'tab-briefcase',
                permission: 'can_show_briefcase',
                more: {
                    title: '',
                    url: '/?_f=briefcasev2',
                    action: 'loadBriefcaseTab',
                    linkedid: '{linkedid}',
                    linkedtype: '{linkedtype}',
                    linkedtypeDir: 'thirds',
                    linkedname: '{linkedname}',
                    editpermission: 'editclient',
                    buttons: [],
                },
            },
        ],
    },
];

var databots = {
    activity: 'supplier-overview__menu--activity',
    informations: 'supplier-overview__menu--general-info',
    financialactivity: 'supplier-overview__menu--financial-info',
    contacts: 'supplier-overview__menu--contact-linked',
    addresses: 'supplier-overview__menu--address',
    customfields: 'supplier-overview__menu--cf',
    statistics: 'supplier-overview__menu--stat',
    opportunity: 'supplier-overview__menu--opportunity',
    estimate: 'supplier-overview__menu--document',
    purOrder: 'supplier-overview__menu--document',
    purDelivery: 'supplier-overview__menu--document',
    purInvoice: 'supplier-overview__menu--document',
    purCreditNote: 'supplier-overview__menu--document',
    payments: 'supplier-overview__menu--payment',
    bankaccount: 'supplier-overview__menu--bank-account',
    tickets: 'supplier-overview__menu--ticket',
    project: 'supplier-overview__menu--project',
    proposal: 'supplier-overview__menu--proposal',
    emailingprofile: 'supplier-overview__menu--mailing-list',
    massmailingMailinglist: 'supplier-overview__menu--mailing-list',
    massmailingCampaignList: 'supplier-overview__menu--mailing-list',
    receipts: 'supplier-overview__menu--receipt',
    briefcase: 'supplier-overview__menu--briefcase',
    activitycommentadd: 'supplier-overview__activity--comment-add',
    emailadd: 'supplier-overview__activity--email-add',
    calladd: 'supplier-overview__activity--call-add',
    scheduledcalladd: 'supplier-overview__activity--scheduled-call-add',
    taskadd: 'supplier-overview__activity--task-add',
    eventadd: 'supplier-overview__activity--event-add',
    generalinfoedit1: 'supplier-overview__section--general-info-edit-1',
    generalinfoedit2: 'supplier-overview__section--general-info-edit-2',
};

setDatabotsNavMap(navMap, databots);

export {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    entitiesGroups,
    entitiesTabs,
    defaultEntities,
    forcedLabel,
    object,
    moreNav,
    databots,
    agendaViewConfig,
    // SellsyAdmin
    sellsyAdminCommonTabs,
    samTabs,
};
